import { useState } from 'react'

import { useDecision } from '@optimizely/react-sdk'
import { ScreenSizes } from '@space-core/styles'
import { AuthStatus, useAuthContext } from '@space-shell/common/contexts/auth'
import type { Product } from '@space-shell/common/services/sections'

import ProductContext from './context'
import type { ProductProviderProps } from './types'

const ProductProvider = ({ children }: ProductProviderProps) => {
  const [product, setProduct] = useState<Product>({} as Product)

  const { authStatus } = useAuthContext()
  const isAuthenticated = authStatus === AuthStatus.AUTHENTICATED
  const enableTestDrawerProduct =
    window.matchMedia(`(max-width: ${ScreenSizes.lg})`)?.matches && !isAuthenticated
  const [{ enabled: isTestDrawerProduct }] = useDecision(
    'club_for_sale_products_acess',
    {},
    { overrideAttributes: { ['isNotLogged']: enableTestDrawerProduct } }
  )

  const handleSetProduct = (product: Product) => {
    setProduct(product)
  }

  return (
    <ProductContext.Provider
      value={{
        isTestDrawerProduct,
        product,
        methods: {
          setProduct: handleSetProduct
        }
      }}>
      {children}
    </ProductContext.Provider>
  )
}

export default ProductProvider
